var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.SCAN_STATUS_ENUM = {
    UNKNOWN: 'UNKNOWN',
    CLEAN: 'CLEAN',
    INFECTED: 'INFECTED'
};

Object.freeze(Enum.MEEDY.SCAN_STATUS_ENUM);